module.exports = "<p>\r\n  awsop-lab12 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab12/awsop-lab12.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab12/awsop-lab12.component.html
// module chunks = main